require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M37.5 4.168a6.25 6.25 0 1 0 .002 12.498A6.25 6.25 0 0 0 37.5 4.168zm0 29.164a6.25 6.25 0 1 0 .002 12.502 6.25 6.25 0 0 0-.002-12.502zm-25-14.582A6.248 6.248 0 0 0 6.25 25a6.248 6.248 0 0 0 6.25 6.25A6.248 6.248 0 0 0 18.75 25a6.248 6.248 0 0 0-6.25-6.25zm0 0"
  }), _react["default"].createElement("path", {
    fill: "none",
    stroke: "#000",
    "stroke-miterlimit": "10",
    "stroke-width": "4.16666",
    d: "M37.5 39.582L12.5 25l25-14.582"
  }));
};

exports["default"] = _default;